/**
 * Handles pagination by hiding links when pagination list is very long
 */

var handlePagination = function(selector) {
    const _handleLinks = function(listElement, index) {

        var listElement = $(listElement);
        if(typeof listElement !== 'undefined') {
            var paginationNum = parseInt(listElement.children('a').text());
            if(paginationNum > 0) {
                // console.log(paginationNum + ", "+settings.overRideToLeft+", "+settings.overRideToRight+", ", settings.currentPage);
                var isBetween = paginationNum >= settings.overRideToLeft && paginationNum <= settings.overRideToRight;

                listElement.addClass('pagination-item-'+paginationNum);

                //Let's by pass first and last items
                //if(paginationNum > 1 && paginationNum < settings.lastPage) {
                    //if current iteration is the elements to overRideToLeft
                    if(paginationNum === settings.overRideToLeft || paginationNum === settings.overRideToRight) {
                        listElement.find('a').text(placeholderTextForMorePagesLink);
                    }

                    //If not between, let's hide
                    if(!isBetween) {
                        listElement.hide();
                    }
                //}
            }
        }
    };
    let paginationContainer = null;
    const paginationLinkIdentifier = '.page-item';
    const settings = {
        visiblePageLinksNextToCurrent: 3,
        pageCountTreshold: 9,
        currentPage: 1,
        lastPage: null,
        overRideToRight: 0,
        overRideToLeft: 0
    };
    const placeholderTextForMorePagesLink = '...';

    const _init = function () {
        //console.log("element: ", $(this));
        paginationContainer = $(this);
        settings.currentPage = parseInt(paginationContainer.children('.active').children('a').text());
        settings.overRideToRight = settings.currentPage + settings.visiblePageLinksNextToCurrent;
        settings.overRideToLeft = settings.currentPage - settings.visiblePageLinksNextToCurrent;

        const pageLinks = paginationContainer.children(paginationLinkIdentifier);

        if (pageLinks.length > settings.pageCountTreshold) {
            const pageLinksArray = Array.prototype.slice.call(pageLinks);

            settings.lastPage = parseInt(pageLinksArray.length);
            pageLinksArray.forEach(_handleLinks);
        }

    };


    if(!selector)
        return;
    $(selector).each(_init);
}
window.handlePagination = handlePagination;
export default handlePagination;